<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        了解现代汉语音韵知识 给孩子起一个好听的名字
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月19日</Col>
      </Row>
      <p></p>
      <h2 style="text-align:center;">《起名废急救指南》 </br>
        第二章 第四节 了解现代汉语音韵知识 给孩子起一个好听的名字</h2>
      <p></p>
      <h4>一，人体发音器官</h4>
      <p>包括肺和气管、喉头和声带、口腔和鼻腔。详细如下图：</p>
      <div class="contentImg">
        <img src="@/assets/article61.jpg" />
      </div>
      
      <p>绕口令读起来觉得很难受，就是因为绕口令不断地使用同一个部位或者相近的部位来重复发音，导致我们读起来很不舒服。所以对于起名而言，我们也要注意不要起一个“绕口令”式的名字，给别人添麻烦，要是别人喊你名字经常咬舌头，那就不好了。</p>
      <h4>二，元音和辅音</h4>
      <p>从音色角度划分为：</p>
      <p>A、辅音：发音时气流在口腔或咽头受阻碍而形成的音叫辅音，又叫子音。普通话中有22个辅音：b p m f d t n l k ɡ h j q x zh ch sh r z c s nɡ</p>
      <p>B、元音：发音时气流振动声带，在口腔或咽头不受阻碍而形成的音叫元音，又叫母音。普通话中有10个元音：ɑ o e ê i u ü er –i（舌尖前zi ci si） -i（舌尖后zhi chi shi）。</p>
      <h4>三，音节</h4>
      <p>音节是语音结构的基本单位，也是自然感到的最小的语音片断。由一个或几个音素组成。一般来说，一个汉字表示一个音节，儿化了的两个汉字表示一个音节。普通话的音节一般是由声母、韵母、声调构成的。有些比较复杂的音节的韵母包含韵头（又叫介音）、韵腹（又叫主要元音）和韵尾三个部分。韵头开口度较小，响亮度也较差，只能由i、u、u（u加点）三个高元音构成。韵尾指的是一部分韵母后面的收尾部分，有元音韵尾和辅音韵尾。元音韵尾由i、u构成。辅音韵尾由n、ng构成。一个音节最多由四个因素符号拼写，韵腹和声调是每一个音节都必须具有的。</p>
      <h5>3.1、声母有21个。由辅音来充当。</h5>
      <h5>1、声母的发音部位：发音时气流受到阻碍的位置。按此，分为七类：</h5>
      <p>（1）双唇音：b,p,m是由上唇与下唇构成阻碍而发出的音</p>
      <p>（2）唇齿音: f是由上齿与下唇构成阻碍而发出的音</p>
      <p>（3）舌尖前音：z,c,s又叫平舌音，是由舌尖与上齿背构成阻碍而发出的音</p>
      <p>（4）舌尖中音：d,t,n,l是由舌尖与上齿龈构成阻碍而发出的音</p>
      <p>（5）舌尖后音：zh,ch,sh,r又叫翘舌音，是由舌尖与硬腭前部构成阻碍而发出的音</p>
      <p>（6）舌面音：j,q,x是由舌面前部与硬腭前部构成阻碍而发出的音</p>
      <p>（7）舌根音(舌面后音):g,k,h是由舌根与软腭构成阻碍而发出的音</p>
      <h5>2、声母的发音方法：气流破除发音阻碍的方法</h5>
      <p>（1）根据成阻或除阻的方式不同。按此，可以五类：</p>
      <p>A、塞音（暴破音）：b、p、d、t、g、k发音时，发音部位完全闭塞，构成阻碍，气流冲破阻碍，迸裂而出，爆发成声</p>
      <p>B、擦音：f,h,x,sh,r,s发音时，发音部位接近，留有一条窄缝，气流由窄缝中挤出，摩擦成声</p>
      <p>C、塞擦音：z、c、zh、ch、j、q发音时，发音部位先是完全闭塞，然后气流把阻塞部位冲开一条窄缝，再由窄缝中挤出，磨擦成声。可见这类声母兼有塞音与擦音的特点，前半部分像塞音，后半部分像擦音，前后发音过程紧密结合，形成一个完整的辅音</p>
      <p>D、边音：l发音时，舌尖抵住上齿龈，声带振动，气流从舌头的两边通过</p>
      <p>E、鼻音：m、n发音时，口腔中的发音部位完全闭塞，软腭下降，声带振动，气流从鼻腔通过</p>
      <p>（2）根据声带是否振动：分清、浊两类</p>
      <p>A、清音：b、p、d、t、g、k、z、c、zh、ch、j、q、f、s、sh、x、h发音时声带不颤动</p>
      <p>B、浊音：m、n、l、r发音时声带颤动</p>
      <p>（3）根据气流的强弱：分送气音、不送气音两类</p>
      <p>A、送气音：p、t、k、q、 c、ch</p>
      <p>B、不送气音：b、d、g、j、 z、zh</p>
      <p>注：声母表里每组第一个音为不送气音；每组第二个音为送气音。只有是塞音、塞擦音时，才考虑送不送气。普通话的22个辅音当中，除ng（以韵母中出现）不能出现在音节开头，其余21个辅音都可以充当声母。声母共22个，其中一个为零声母。我们将上面的声母特点，总结为如下表格，供大家查阅。在起名的时候，尽量不要选择声母相同或者相似的字，如吕鲤鱼，侯红花之类，这些名字我们称之为绕口令名字，读起来没有韵味不说，还比较绕口。</p>
      <div class="contentImg">
        <img src="@/assets/article62.jpg" />
      </div>
      <p>小贴士：</p>
      <p>1. 为什么小学课本说声母有23个？1958年2月11日，第一届全国人民代表大会第五次会议批准颁布《汉语拼音方案》。里面明确规定声母有21个。</p>
      <div class="contentImg">
        <img src="@/assets/article63.jpg" />
      </div>
      <p>在《汉语拼音方案》规则(4)中将y,w作为“隔音符号”来使用。</p>
      <h5>3.2 韵母</h5>
      <p>韵母有39个，由元音充当。</p>
      <h5>1、普通话韵母的主要成分是元音。韵母的结构可以分为韵头、韵腹、韵尾三个部分</h5>
      <p>（1）韵头—是主要元音前面的元音，又叫介音。由i、u、ü充当，发音总是轻而短，只表示韵母的起点。如ia、ua、üe、iao、uan中的i、u、ü</p>
      <p>（2）韵腹—是韵母中的主要元音。充当韵腹的主要元音口腔开度最大、声音最响亮。韵腹是韵母的主要构成部分，由a、o、e、ê、i、u、ü、-i（前）、-i（后）、er充当 </p>
      <p>（3）韵尾—是韵腹后面的音素，又叫尾音。由i、u或鼻辅音n、ng充当</p>
      <p>（4）韵母中只有一个元音时，这个元音就是韵腹；有2个或3个元音时，开口度最大、声音最响亮的元音是韵腹。韵腹前面的元音是韵头，后面的元音或辅音是韵尾。韵腹是韵母的主要成分，一个韵母可以没有韵头或韵尾，但是不可以没有韵腹</p>
      <h5>2、根据韵母的组成成分，分为单元音韵母、复元音韵母、鼻音韵母三类</h5>
      <p>（1）单元音韵母：发音时舌位，唇形及开口度适中不变得元音叫单元音。单元音韵母共有10个，即：</p>
      <p>A、舌面元音（a、o、e、ê、i、u、ü）</p>
      <p>B、舌尖元音（-i、-i）</p>
      <p>C、卷舌元音（er）</p>
      <p>（2）复元音韵母：共有13个，即：</p>
      <p>A、前响复合韵母：ai、ei、ao、ou；</p>
      <p>B、后响复合韵母：ia、ie、ua、uo、üe；</p>
      <p>C、中响复合韵母：iao、iou、uai、uei</p>
      <p>（3）鼻音韵母：共有16个鼻音韵母，即：</p>
      <p>A、舌尖中鼻音韵母8个：an、ian、uan（u加点）、uan、en、in、uen、un（u加点）</p>
      <p>B、舌根鼻音韵母8个：ang、iang、uang、eng、ing、ueng、ong、iong</p>
      <h5>3、所谓四呼就是按韵母开头的元音口形分类</h5>
      <p>（1）开口呼：韵母不是i、u、ü 或不以i、u、ü起头的韵母属开口呼</p>
      <p>（2）齐齿呼：i或以i起头的韵母属齐齿呼</p>
      <p>（3）合口呼：u或以u起头的韵母属合口呼</p>
      <p>（4）撮口呼：ü或以ü起头的韵母属撮口呼</p>
      <p>注：ong[ug]放在合口呼，iong[yg]放在撮口呼，是按它的实际读音排列的和声母类似，我们将韵母的特点也作出速查表供大家参考，起名时尽量避免“叠韵”，即韵母相同或者相似。我们也不建议使用叠词，如李可可这样的名字，这样的名字总给人一种小名的感觉，等长大后叫起来不太合适。</p>
      <div class="contentImg">
        <img src="@/assets/article64.jpg" />
      </div>
      <h5>3.3声调</h5>
      <p>普通话的声调有四个调值：阴平、阳平、上声、去声。</p>
      <p>起名时，声调最好“抑扬顿挫”，富有变化，避免单调乏味的使用相同的声调。由于起名时，姓氏已经确定，姓氏的音调就对整个名字的音调有了潜在的影响。后续文章我们一一分析每个姓氏的详细情况，请大家持续关注</p>
      <h4> 四、多音字和谐音</h4>
      <p>汉字还有另外一个特殊的现象，即多音字。我们建议名字中绝对不能出现常用多音字，所谓常用多音字就是多个音都是常用字，例如李乐，王立行，这些名字中的“乐”，“行”，日常中的快乐，音乐，行走，银行，都非常常见，由于名字字数少，缺少必要的上下文信息，导致极易读错，给别人带来麻烦，也必然会给自己带来麻烦。</p>
      <p>汉字的一种读音往往有多个汉字，例如wang，有王、亡，这就导致一个名字听起来极易让人联想到其他词，如大名鼎鼎的“史尚飞”。其实，汉字的音节类型是很少的，一共才413种，我们曾做过如下统计，供大家参考：</p>
      <div class="contentImg">
        <img src="@/assets/article65.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article66.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article67.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article68.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article69.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article610.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article611.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article612.jpg" />
      </div><div class="contentImg">
        <img src="@/assets/article613.jpg" />
      </div>
      <p>最多的为yi，可选字就很多，如一，伊，以，义等，对于这种音节，谐音的可能性也就越大，选择的时候一定要仔细看看，“姓名图谱”小程序自动做了谐音识别，大家起名的时候可以看看。</p>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .listai {
    .contentImg {
      text-align: center;
      img {
        width: 600px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
      text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }
  }
}
</style>
